import { Button, Card, Stack, Theme, useMediaQuery } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

import { FCWithChildren } from '/common/models';
import { withLoading } from '/common/withLoading';

import { handleCopyClick } from '../BeetlesLookup/helpers';
import { MobileFooter } from '../BeetlesLookup/styles';

import { Title } from './Title';
import { BeetleBreadcrumbs, SupportBreadcrumbsRoute, useGetRoutes } from './BeetleBreadcrumbs';

interface IBeetlesLookupWrapper {
  title?: string | Partial<{ name: string; templateName: string }>;
  homeRoute?: boolean;
  module: SupportBreadcrumbsRoute;
  cardHeaderProps?: { subheader?: string; action?: React.JSX.Element; title?: string };
  showAdminButtons?: React.JSX.Element | null;
  showFooter?: boolean;
  isLoading?: boolean;
  pagination?: React.JSX.Element;
}
const CardWithLoading = withLoading(Card);

export const HeaderSection: FCWithChildren<IBeetlesLookupWrapper> = ({
  children,
  isLoading,
  title,
  module,
  homeRoute = false,
  cardHeaderProps,
  showFooter = false,
  pagination,
}) => {
  const routes = useGetRoutes({ module, title });
  const matches = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
  const isMobileVersion = matches && showFooter;

  const breadcrumbs = <BeetleBreadcrumbs routes={routes} mobile={matches} homeRoute={homeRoute} />;
  return (
    <CardWithLoading isLoading={isLoading}>
      <Stack direction={{ xs: 'column-reverse', sm: 'column' }} gap={{ xs: 2, sm: 4 }} p={2}>
        <Title
          {...cardHeaderProps}
          title={cardHeaderProps?.title ?? module}
          sx={{ p: 0, height: '38px' }}
          action={
            isMobileVersion ? (
              <Button
                onClick={handleCopyClick}
                variant='text'
                disableRipple
                sx={{ color: '#2EA0E0', alignItems: 'center' }}
                endIcon={<ContentCopy />}
              >
                Copy link
              </Button>
            ) : (
              cardHeaderProps?.action
            )
          }
        />
        {pagination ? (
          <Stack direction='row' justifyContent='space-between' alignItems='center'>
            {breadcrumbs}
            {pagination}
          </Stack>
        ) : (
          breadcrumbs
        )}
      </Stack>

      {children}
      {isMobileVersion ? <MobileFooter elevation={3}>{cardHeaderProps?.action}</MobileFooter> : null}
    </CardWithLoading>
  );
};
